import { api } from 'utility';
import {
  getGuildServiceUrl,
  getCreditUrl,
  getBusinessBranchCreditUrl,
  getFinancialCreditForOtherUrl,
} from 'URLs';
// Cards
export function checkBalance() {
  return api.get(getCreditUrl()).then((res) => res.data.result?.customerAmountSrvs[0]?.amount);
}

export function getCredit(params) {
  return api.get(getFinancialCreditForOtherUrl(), { params }).then((res) => res.data.result.amount);
}
export function getGuilds() {
  return api.get(getGuildServiceUrl()).then((res) => res.data);
}

export function businessCredit(params, branchId) {
  return api.get(getBusinessBranchCreditUrl(branchId), { params }).then((res) => res.data);
}

export default {
  checkBalance,
  getCredit,
  getGuilds,
  businessCredit,
};
